import type { AnchorDisplayModel } from "./anchor-display-model";

const copy = {
	incomplete: "Anchor unavailable — inflation data was not fully saved.",
	driftGain: (pct: number) => `+${pct}% purchasing power`,
	driftLoss: (pct: number) => `${pct}% purchasing power`,
	noChange: "No change in purchasing power",
	currently: "Currently:",
	preview: "Preview:",
};

function driftText(pct: number | null): string | null {
	if (pct == null) return null;
	if (pct === 0) return copy.noChange;
	return pct > 0 ? copy.driftGain(pct) : copy.driftLoss(pct);
}

export interface AnchorDisplayBlockProps {
	model: AnchorDisplayModel;
	previewModel?: AnchorDisplayModel | null;
	showPreviewLabel?: boolean;
}

export function AnchorDisplayBlock({
	model,
	previewModel,
	showPreviewLabel = false,
}: AnchorDisplayBlockProps) {
	if (model.state === "none") return null;

	if (model.state === "incomplete") {
		return (
			<div className="anchor-row anchor-row--warn" role="status">
				<p className="anchor-incomplete">{copy.incomplete}</p>
			</div>
		);
	}

	const drift = driftText(model.driftPercent);

	return (
		<div className="anchor-display" role="group">
			{showPreviewLabel && (
				<p className="anchor-section-label">{copy.currently}</p>
			)}
			<div className="anchor-pill">{model.pillLabel}</div>
			<p className="anchor-detail">{model.detailLine}</p>
			{model.rateBanner && (
				<p className="anchor-rate-banner">{model.rateBanner}</p>
			)}
			{drift && model.showActual && (
				<p
					className={`anchor-drift ${model.driftPercent! > 0 ? "anchor-drift--gain" : model.driftPercent! < 0 ? "anchor-drift--loss" : ""}`}
				>
					{drift}
				</p>
			)}

			{previewModel && previewModel.state === "complete" && (
				<div className="anchor-preview">
					<p className="anchor-section-label">{copy.preview}</p>
					<div className="anchor-pill anchor-pill--preview">
						{previewModel.pillLabel}
					</div>
					{driftText(previewModel.driftPercent) && (
						<p className="anchor-drift anchor-drift--preview">
							{driftText(previewModel.driftPercent)}
						</p>
					)}
				</div>
			)}
		</div>
	);
}
